import { render, staticRenderFns } from "./saveUpdate.vue?vue&type=template&id=ee008d1c&scoped=true"
import script from "./saveUpdate.vue?vue&type=script&lang=js"
export * from "./saveUpdate.vue?vue&type=script&lang=js"
import style0 from "./saveUpdate.vue?vue&type=style&index=0&id=ee008d1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee008d1c",
  null
  
)

export default component.exports